<section class="ml-28 mr-8 h-full">
  <div role="row" class="suggestionsGrid mt-5 mb-4 text-center items-center">
    <div
      role="columnheader"
      class="flex justify-center items-center gap-1"
      app-sortable-column-header
      [icon]="images.suggestions.sortOptions.status"
      labelKey="suggestions.data.status"
      [ariaSort]="ariaSortByType()[SuggestionSortType.STATUS]"
      (sort)="sortBy(SuggestionSortType.STATUS)"
    >
      @if (priorityAndStatusColumnFiltersVisible) {
        <app-column-filter
          id="suggestionsStatusFilter"
          [icon]="images.filter"
          [label]="literalService.get('suggestions.columnFilters.status', true)"
          [loader]="statusFilterSource.loader"
          [toOption]="statusFilterSource.toOption"
          [searchable]="false"
          [selected]="filters().selectedStatus"
          (apply)="filterChange.emit({ selectedStatus: $event })"
        />
      }
    </div>
    <div
      role="columnheader"
      class="flex justify-center items-center gap-1"
      app-sortable-column-header
      [icon]="images.suggestions.sortOptions.priority"
      labelKey="suggestions.data.priority"
      [ariaSort]="ariaSortByType()[SuggestionSortType.PRIORITY]"
      (sort)="sortBy(SuggestionSortType.PRIORITY)"
    >
      @if (priorityAndStatusColumnFiltersVisible) {
        <app-column-filter
          id="suggestionsPriorityFilter"
          [icon]="images.filter"
          [label]="literalService.get('suggestions.columnFilters.priority', true)"
          [loader]="priorityFilterSource.loader"
          [toOption]="priorityFilterSource.toOption"
          [searchable]="false"
          [selected]="filters().selectedPriorities"
          (apply)="filterChange.emit({ selectedPriorities: $event })"
        />
      }
    </div>
    <div role="columnheader" class="flex justify-center">
      <app-column-filter
        id="suggestionsTypeFilter"
        [icon]="images.services.tag"
        [label]="literalService.get('suggestions.data.type', true)"
        [loader]="typeFilterSource.loader"
        [toOption]="typeFilterSource.toOption"
        [searchable]="false"
        [selected]="filters().selectedTypes"
        (apply)="filterChange.emit({ selectedTypes: $event })"
      />
    </div>
    <div role="columnheader" class="flex justify-center">
      <app-column-filter
        id="suggestionsVisibilityFilter"
        [icon]="images.visibility"
        [label]="literalService.get('suggestions.data.visibility', true)"
        [loader]="visibilityFilterSource.loader"
        [toOption]="visibilityFilterSource.toOption"
        [searchable]="false"
        [selected]="filters().selectedVisibilities"
        (apply)="filterChange.emit({ selectedVisibilities: $event })"
      />
    </div>
    <span role="columnheader" class="flex justify-center col-span-2 font-semibold text-base">
      <img [src]="images.suggestions.affair" alt="" aria-hidden="true" class="h-6 w-6 mr-2 filter-primary-purple-light" />
      {{ literalService.get('suggestions.data.affair', true) }}
    </span>
    <span role="columnheader" class="flex justify-center col-span-2 font-semibold text-base">
      @if (userType() === CommunicationUserType.DRIVERS) {
        <img [src]="images.suggestions.driver" alt="" aria-hidden="true" class="h-6 w-6 mr-2 filter-primary-purple-light" />
        {{ literalService.get('suggestions.data.driver', true) }}
      } @else {
        <img [src]="images.suggestions.user" alt="" aria-hidden="true" class="h-6 w-6 mr-2 filter-primary-purple-light" />
        {{ literalService.get('suggestions.data.user', true) }}
      }
    </span>
    <span role="columnheader" class="flex justify-center col-span-2 font-semibold text-base">
      <img [src]="images.suggestions.town" alt="" aria-hidden="true" class="h-6 w-6 mr-2 filter-primary-purple-light" />
      {{ literalService.get('suggestions.data.town', true) }}
    </span>
    <div
      role="columnheader"
      class="flex justify-center min-w-0"
      app-sortable-column-header
      [icon]="images.suggestions.sortOptions.creation"
      labelKey="suggestions.data.created"
      [showLabel]="true"
      [ariaSort]="ariaSortByType()[SuggestionSortType.CREATION]"
      (sort)="sortBy(SuggestionSortType.CREATION)"
    ></div>
    <div
      role="columnheader"
      class="flex justify-center min-w-0"
      app-sortable-column-header
      [icon]="images.suggestions.sortOptions.lastmodification"
      labelKey="suggestions.data.modified"
      [showLabel]="true"
      [ariaSort]="ariaSortByType()[SuggestionSortType.LAST_MODIFICATION]"
      (sort)="sortBy(SuggestionSortType.LAST_MODIFICATION)"
    ></div>
    <div role="columnheader" class="flex justify-center min-w-0">
      <app-column-filter
        id="suggestionsUserResolutionFilter"
        [icon]="images.suggestions.status.processed"
        [label]="literalService.get('suggestions.data.userResolution', true)"
        [caption]="literalService.get('suggestions.data.resolution', true)"
        [loader]="userResolutionFilterSource.loader"
        [toOption]="userResolutionFilterSource.toOption"
        [searchable]="false"
        [selected]="filters().selectedUserResolutions"
        (apply)="filterChange.emit({ selectedUserResolutions: $event })"
      />
    </div>
  </div>
</section>
<section>
  <div id="suggestionsContainer" class="scrollable-content h-[calc(100vh-310px)] ml-25 mr-5 px-3 mb-2 overflow-y-scroll">
    @if (!suggestions()!.isFetchingSuggestion) {
      @for (suggestion of suggestions()!.value; track suggestion.id) {
        @let suggestionStatus = suggestion.status?.toUpperCase();
        @let isRejected = suggestionStatus === SuggestionStatus.REJECTED;
        <div
          [id]="`suggestion${suggestion.id}`"
          class="suggestionRow suggestionsGrid selectable-row border rounded pt-2 pb-2 items-center mb-4"
          [class.rejected]="isRejected"
          [class.pending]="suggestionStatus === SuggestionStatus.PENDING"
          [class.selected-row]="suggestion.id === selectedSuggestionId()"
        >
          <div id="statusesContainer" class="relative flex justify-center">
            <button
              type="button"
              class="inline-flex rounded p-1 cursor-pointer focus-visible:outline-2 focus-visible:outline-primary-purple"
              [attr.aria-label]="`${literalService.get('suggestions.data.status', true)}: ${literalService.get(`suggestions.statuses.${suggestion.status!.toLowerCase()}`)}`"
              [attr.aria-expanded]="showStatusOptions === suggestion.id"
              [tooltip]="literalService.get(`suggestions.statuses.${suggestion.status!.toLowerCase()}`, true)"
              (click)="toggleStatusModal($event, suggestion.id!)"
            >
              <img [src]="suggestionStatusIcon(suggestion.status).src" alt="" aria-hidden="true" class="h-5 w-5" [class]="suggestionStatusIcon(suggestion.status).filterClass" />
            </button>
            @if (showStatusOptions === suggestion.id) {
              <div
                [id]="`actionsModal-statuses-${suggestion.id}`"
                class="absolute left-8 w-52 bg-primary-green-2 z-50 rounded-lg py-4 flex flex-col gap-2"
                [class]="{ '-top-16': $index > 1 && $index < suggestions()!.value.length - 2, 'top-0': $index < 2, '-top-36': $index > suggestions()!.value.length - 3 }"
              >
                <button type="button" (click)="updateStatus(suggestion.id!, SuggestionStatus.PENDING)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                  <img [src]="images.suggestions.status.pending" alt="" aria-hidden="true" class="h-6 w-6 mr-2" />
                  <span class="cursor-pointer">{{ literalService.get('suggestions.statuses.pending', true) }}</span>
                </button>
                <button type="button" (click)="updateStatus(suggestion.id!, SuggestionStatus.IN_PROGRESS)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                  <img [src]="images.suggestions.status.inProgress" alt="" aria-hidden="true" class="h-6 w-6 mr-2" />
                  <span class="cursor-pointer">{{ literalService.get('suggestions.statuses.in_progress', true) }}</span>
                </button>
                <button type="button" (click)="updateStatus(suggestion.id!, SuggestionStatus.PROCESSED)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                  <img [src]="images.suggestions.status.processed" alt="" aria-hidden="true" class="h-6 w-6 mr-2" />
                  <span class="cursor-pointer">{{ literalService.get('suggestions.statuses.processed', true) }}</span>
                </button>
                <button type="button" (click)="updateStatus(suggestion.id!, SuggestionStatus.REJECTED)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                  <img [src]="images.suggestions.status.rejected" alt="" aria-hidden="true" class="h-6 w-6 mr-2" />
                  <span class="cursor-pointer">{{ literalService.get('suggestions.statuses.rejected', true) }}</span>
                </button>
              </div>
            }
          </div>

          <div id="prioritiesContainer" class="relative flex justify-center">
            <button
              type="button"
              class="inline-flex rounded p-1 cursor-pointer focus-visible:outline-2 focus-visible:outline-primary-purple"
              [attr.aria-label]="`${literalService.get('suggestions.data.priority', true)}: ${literalService.get(`suggestions.priorities.${suggestion.priority!.toLowerCase()}`)}`"
              [attr.aria-expanded]="showPriorityOptions === suggestion.id"
              [tooltip]="literalService.get(`suggestions.priorities.${suggestion.priority!.toLowerCase()}`, true)"
              (click)="togglePriorityModal($event, suggestion.id!)"
            >
              @if (suggestionPriorityIcon(suggestion.priority); as priorityIcon) {
                <img [src]="priorityIcon.src" alt="" aria-hidden="true" class="h-5 w-5" [class]="priorityIcon.filterClass" [class.rejected]="isRejected" />
              }
            </button>
            @if (showPriorityOptions === suggestion.id) {
              <div
                [id]="`actionsModal-priorities-${suggestion.id}`"
                class="absolute left-8 w-52 bg-primary-green-2 z-50 rounded-lg py-4 flex flex-col gap-2"
                [class]="{ '-top-16': $index > 1 && $index < suggestions()!.value.length - 2, 'top-0': $index < 2, '-top-36': $index > suggestions()!.value.length - 3 }"
              >
                <button type="button" (click)="updatePriority(suggestion.id!, SuggestionPriorities.LOW)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                  <img [src]="images.suggestions.priority.low" alt="" aria-hidden="true" class="h-6 w-6 mr-2" />
                  <span class="cursor-pointer">{{ literalService.get('suggestions.priorities.low', true) }}</span>
                </button>
                <button type="button" (click)="updatePriority(suggestion.id!, SuggestionPriorities.MEDIUM)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                  <img [src]="images.suggestions.priority.medium" alt="" aria-hidden="true" class="h-6 w-6 mr-2" />
                  <span class="cursor-pointer">{{ literalService.get('suggestions.priorities.medium', true) }}</span>
                </button>
                <button type="button" (click)="updatePriority(suggestion.id!, SuggestionPriorities.HIGH)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                  <img [src]="images.suggestions.priority.high" alt="" aria-hidden="true" class="h-6 w-6 mr-2" />
                  <span class="cursor-pointer">{{ literalService.get('suggestions.priorities.high', true) }}</span>
                </button>
                <button type="button" (click)="updatePriority(suggestion.id!, SuggestionPriorities.HIGHEST)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                  <img [src]="images.suggestions.priority.highest" alt="" aria-hidden="true" class="h-6 w-6 mr-2" />
                  <span class="cursor-pointer">{{ literalService.get('suggestions.priorities.highest', true) }}</span>
                </button>
              </div>
            }
          </div>

          <div class="flex justify-center" [tooltip]="literalService.get(`suggestions.${suggestion.type!.toLowerCase()}`, true)">
            <img
              [src]="suggestionTypeIcon(suggestion.type)"
              [alt]="literalService.get(`suggestions.${suggestion.type!.toLowerCase()}`, true)"
              class="h-5 w-5"
              [class.rejected]="isRejected"
            />
          </div>

          <a
            class="suggestionLink col-span-10 grid grid-cols-subgrid items-center no-underline text-inherit"
            [href]="`/suggestions/${userType()}/${suggestion.id}`"
            (click)="openSuggestion($event, suggestion.id!)"
          >
            <span class="flex justify-center">
              <img
                [src]="suggestionVisibilityIcon(suggestion.visibility)"
                [alt]="literalService.get(`suggestions.visibilities.${suggestion.visibility ?? SuggestionVisibility.PRIVATE}`, true)"
                class="h-5 w-5 filter-primary-purple"
                [tooltip]="visibilityTooltip(suggestion)"
                [position]="TooltipPosition.DYNAMIC"
              />
            </span>
            <span
              [id]="`name-${suggestion.id}`"
              class="truncate px-3 col-span-2 text-base"
              [tooltip]="utilsService.visibleTooltip(`name-${suggestion.id}`) ? literalService.get('suggestions.affairs.' + suggestion.affair, true) : ''"
              [visibleTooltip]="utilsService.visibleTooltip(`name-${suggestion.id}`)"
              [position]="TooltipPosition.DYNAMIC"
            >
              {{ literalService.get('suggestions.affairs.' + suggestion.affair, true) }}
            </span>
            <span
              [id]="`user-${suggestion.id}`"
              class="truncate px-3 col-span-2 text-base"
              [tooltip]="(utilsService.visibleTooltip(`user-${suggestion.id}`) && suggestion.userSuggester?.id) ? getUserSuggesterName(suggestion) : ''"
              [visibleTooltip]="utilsService.visibleTooltip(`user-${suggestion.id}`)"
              [position]="TooltipPosition.DYNAMIC"
            >
              {{ getUserSuggesterName(suggestion) }}
            </span>
            <span
              [id]="`town-${suggestion.id}`"
              class="truncate px-3 col-span-2 text-base"
              [tooltip]="(utilsService.visibleTooltip(`town-${suggestion.id}`) && suggestion.town) ? suggestion.town.name! : ''"
              [visibleTooltip]="utilsService.visibleTooltip(`town-${suggestion.id}`)"
              [position]="TooltipPosition.DYNAMIC"
            >
              {{ suggestion.town?.name || '-' }}
            </span>
            <span [id]="`creation-${suggestion.id}`" class="truncate px-3 text-base">
              {{ suggestion.createdAt | date: 'yyyy-MM-dd' }}
            </span>
            <span [id]="`lastModification-${suggestion.id}`" class="truncate px-3 text-base">
              {{ (suggestion.lastModifiedAt | date: 'yyyy-MM-dd') || '-' }}
            </span>
            <span class="flex justify-center min-w-0 px-1">
              @if (suggestion.userResolution) {
                <span class="badge badge-sm whitespace-nowrap truncate" [class]="suggestionUserResolutionBadgeClass(suggestion.userResolution)">
                  {{ literalService.get('suggestions.userResolutions.' + suggestion.userResolution, true) }}
                </span>
              } @else {
                -
              }
            </span>
          </a>
        </div>
      }
    } @else {
      <ngx-skeleton-loader [count]="suggestions()?.pagination?.size || 10" appearance="line" [theme]="{ 'height': '40px' }"></ngx-skeleton-loader>
    }
  </div>
</section>
